
import React, {useState} from 'react';
import BilderMartrix from "../BilderMartrix/BilderMartrix_"

const besetzung = [ 
  
  {
    "id":"tenor_1",
    "header":"1. Tenor",
    "bgimg": ["./images/tenor_one.png"],
    "members":9,
    "description":[      
      {"name":"Hans-Otto Schütze","img":"./mitglieder/thumbnails/portrait32_t.jpg"},
      {"name":"Erhard Leubner","img":"./mitglieder/thumbnails/portrait34_t.jpg"},       
      {"name":"Jürgen Kramer","img":"./mitglieder/thumbnails/portrait35_t.jpg"},      
      {"name":"Wolfgang Harnisch","img":"./mitglieder/thumbnails/portrait31_t.jpg"},
      {"name":"Klaus Stelzer","img":"./mitglieder/thumbnails/portrait33_t.jpg"}, 
      {"name":"Erich Grützmann","img":"./mitglieder/thumbnails/portrait29_t.jpg"},      
      {"name":"Willy Rienecker","img":"./mitglieder/thumbnails/portrait36_t.jpg"},  
      {"name":"Klaus Sölter","img":"./mitglieder/thumbnails/portrait30_t.jpg"},     
      {"name":"Klaus Dunte","img":"./mitglieder/thumbnails/portrait37_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},      
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"}
    ]
    
  },
  {
    "id":"tenor_2",
    "header":"2. Tenor",
    "bgimg": ["./images/tenor_two.png"],
    "members":7,
    "description":[      
     /*  {"name":"Ernst Peter","img":"./mitglieder/thumbnails/portrait26_t.jpg"},  */
      {"name":"Thomas Schütze","img":"./mitglieder/thumbnails/portrait27_t.jpg"},      
      {"name":"Heiner Jänecke","img":"./mitglieder/thumbnails/portrait23_t.jpg"},     
      {"name":"Heiko Grützmann","img":"./mitglieder/thumbnails/portrait24_t.jpg"},
      {"name":"Bernd Günther","img":"./mitglieder/thumbnails/portrait28_t.jpg"},     
      {"name":"Willi Heik","img":"./mitglieder/thumbnails/portrait22_t.jpg"},      
      {"name":"Maik Egeling","img":"./mitglieder/thumbnails/portrait25_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},    
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},     
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"}
    ]   
            
  },
  {
    "id":"bass_1",
    "header":"1. Bass",
    "bgimg": ["./images/bass_one.png"],
    "members":13,
    "description":[
      {"name":"Mike Lehmann","img":"./mitglieder/thumbnails/portrait17_t.jpg"},
      {"name":"Bernd Koch","img":"./mitglieder/thumbnails/portrait19_t.jpg"},
      {"name":"Martin Schäfer","img":"./mitglieder/thumbnails/portrait20_t.jpg"},
      {"name":"Dieter Weddig","img":"./mitglieder/thumbnails/portrait12_t.jpg"},      
      {"name":"Renne Stelzer","img":"./mitglieder/thumbnails/portrait18_t.jpg"},      
      {"name":"Axel Klingler","img":"./mitglieder/thumbnails/portrait15_t.jpg"},
      {"name":"Dieter Sölter","img":"./mitglieder/thumbnails/portrait16_t.jpg"},
      {"name":"Reiner Wiechmann","img":"./mitglieder/thumbnails/portrait14_t.jpg"},
      {"name":"Felix Meyer","img":"./mitglieder/thumbnails/portrait21_t.jpg"},      
      {"name":"Matthias Wenisch","img":"./mitglieder/thumbnails/portrait11_t.jpg"},            
      {"name":"Dieter Zahn","img":"./mitglieder/thumbnails/portrait13_t.jpg"},       
      {"name":"Walter Pflaumbaum","img":"./mitglieder/thumbnails/portrait39_t.jpg"}, 
      {"name":"Dr. Jürgen Ritter","img":"./mitglieder/thumbnails/portrait40_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"}, 
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
     
    ]            
  },
  {
    "id":"bass_2",
    "header":"2. Bass",
    "bgimg": ["./images/bass_two.png"],
    "members":12,
    "description":[
      {"name":"Markus Kärner","img":"./mitglieder/thumbnails/portrait7_t.jpg"},
      {"name":"Eckhardt Nebe","img":"./mitglieder/thumbnails/portrait0_t.jpg"},
      {"name":"Adolf Geib","img":"./mitglieder/thumbnails/portrait2_t.jpg"},
      {"name":"Bernd Ermisch","img":"./mitglieder/thumbnails/portrait1_t.jpg"},
      {"name":"Andreas Rienecker","img":"./mitglieder/thumbnails/portrait8_t.jpg"},      
      {"name":"Walter Warzügel","img":"./mitglieder/thumbnails/portrait9_t.jpg"},
      {"name":"Steffen Möbes","img":"./mitglieder/thumbnails/portrait3_t.jpg"},     
      {"name":"Tobias Nebe","img":"./mitglieder/thumbnails/portrait5_t.jpg"},
      {"name":"Sebastian Schäfer","img":"./mitglieder/thumbnails/portrait6_t.jpg"},      
      {"name":"Jens Geiler","img":"./mitglieder/thumbnails/portrait10_t.jpg"},
      {"name":"André Jänecke","img":"./mitglieder/thumbnails/portrait4_t.jpg"},
      {"name":"Thomas Schneider","img":"./mitglieder/thumbnails/portrait38_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"},
      {"name":"","img":"./mitglieder/thumbnails/portraitDummy_t.jpg"}
      
    
    ]            
  }
]



function App(props) {  

 /*  const [dimensions, setDimensions] = React.useState({ 

    height: window.innerHeight,

    width: window.innerWidth

  })

  React.useEffect(() => {

    function handleResize() {

      setDimensions({

        height: window.innerHeight,

        width: window.innerWidth

      })

    

}


    window.addEventListener('resize', handleResize)

  })
 */

    return (
      <div className="component-view animate" data-animate="blendin 3s">
         
         
         <div className="portrait-text-view" >
               <div className="text-item text-header">
               Leitung des Chores
              </div>
              <img className="image-view" src="./images/foto11_1024.png"/>
             
              <div className="text-item ">
              Prof. Dr. Rolf Braun
              </div>            
          </div>
         
         <div   className="flex-row-view">
         
        {
            besetzung.map((item) => {              
                return <BilderMartrix item={item}/>
            })
        }
      </div>

      

          
      </div>
            );
        }
    
    export default App;